import { ColorService } from '@tableau/vizportalclient-common-components';
import { cssRule } from 'typestyle';

import { supportedThemeSVGs } from '~src/style/ThemeSupportedSVGList';

import { Location } from './Location';

export function imgPath(img: string) {
  if (ColorService.instance.getTheme() === 'tds-dark' && supportedThemeSVGs[img]) {
    img = img.replace('.svg', '_tds-dark.svg');
    img = img.replace('.png', '_tds-dark.png');
  }

  return ((window as any).StaticAssetsUrlPrefix || '') + `img/${img}?${((window as any).BuildId || '')}`;
}

export function imgLangPath(img: string, lang: string) {
  const dotIndex = img.lastIndexOf('.');
  if (dotIndex === -1) return `${img}_${lang}`; // fallback if no extension

  const name = img.substring(0, dotIndex);
  const ext = img.substring(dotIndex);
  return StaticAssetsUrlPrefix + `img/${name}_${lang}${ext}`;
}

export function imgUrl(img: string) {
  const path = imgPath(img);
  return `url(${path})`;
}

export function backgroundImageUrl(img: string) {
  const path = imgPath(img);
  return `url("${path}")`;
}

export function initializeUrlPrefix(prefix: string) {
  StaticAssetsUrlPrefix = prefix ? (prefix + '/') : '';
  if (Location.instance.hostname().toLowerCase() === 'localhost' && Location.instance.search().toLowerCase().indexOf('usecdn') === -1) {
    StaticAssetsUrlPrefix = '';
  }

  if (StaticAssetsUrlPrefix) {
    // Currently there are many CSS styles are defined with "CSSRule" function which are migrated from the previous Stylus code.
    // Those "CSSRule" function call generates CSS rules before the VPC application is initialized.
    // In order to continue letting the image URLs generated by those "CSSRule" function calls to consume the CDN prefix,
    // We have to manipulate the actual stylesheets dynamically during the run time.
    const stylesheets = document.styleSheets;
    for (let i = 0; i < stylesheets.length; i++) {
      const stylesheet = stylesheets[i];
      for (let j = 0; j < stylesheet.cssRules.length; j++) {
        const cssStyleRule = stylesheet.cssRules[j] as CSSStyleRule;
        try {
          if (cssStyleRule.style && cssStyleRule.style.backgroundImage && cssStyleRule.style.backgroundImage.indexOf('url("img/') !== -1) {
            const newImageURL = cssStyleRule.style.backgroundImage.replace(/url\("img\//g, 'url("' + StaticAssetsUrlPrefix + 'img/');
            ColorService.instance.globalContainer.cdnImageMap[cssStyleRule.style.backgroundImage] = newImageURL;
            cssRule(cssStyleRule.selectorText, { backgroundImage: newImageURL });
          }

          const cssFontFaceRule = stylesheet.cssRules[j] as CSSFontFaceRule;
          if (cssFontFaceRule.style && cssFontFaceRule.style.getPropertyValue('src').indexOf('url("img/') !== -1) {
            cssFontFaceRule.style.setProperty('src', cssFontFaceRule.style.getPropertyValue('src').replace(/url\("img\//g, 'url("' + StaticAssetsUrlPrefix + 'img/'));
          }
        } catch (e) {
          // for any case if the CSS manipulation fails, igonre the failure to avoid breaking the whole page.
        }
      }
    }
  }
}